import React from 'react';
import Select from 'react-select';

const UnAvailableReasons = (props) => {
	const {
		selectHandler,
		ReasonsData,
		ReasonsForRej,
		otherReason,
		onChangeHandler,
		RequiedFields,
		interviewDetails
	} = props;

	return (
		<div className="parentBoxDiv border">
			<div className="formWrapper" style={{ minHeight: '100px' }}>
				<div className="row">
					<div className="col-xs-12 col-md-4">
						<label className="appFormLabel " style={{fontWeight:"bold"}}>
							<span className="requiredText">*</span>
							Reasons for Non-Availability
						</label>
					</div>
					<div className="col-md-5 col-xs-12">
						<Select
							className="z-depth-3"
							options={ReasonsForRej}
							onChange={(selected) => selectHandler(selected, 'RejectionReason')}
							value={ReasonsData}
							isDisabled={interviewDetails.editable === false ? true : false}
							menuPlacement='auto'
						/>
						{RequiedFields.RejectionReasonReqError ? (
							<p className="RoundValidationError">
								<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
							</p>
						) : null}
					</div>
				</div>
				{ReasonsData.label === 'Other' ? (
					<div className="row">
						<div className="col-xs-12 col-md-4 ">
							<label className="appFormLabel " style={{fontWeight:"bold"}}>
								<span className="requiredText">*</span>
								Other reason
							</label>
						</div>
						<div className="col-md-5 col-xs-12 pt-2">
							<input
								className="form-control"
								name="otherReason"
								value={otherReason}
								onChange={onChangeHandler}
								disabled={interviewDetails.editable === false ? true : false}
							/>
							{RequiedFields.otherReasonReqError ? (
								<p className="RoundValidationError">
									<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
								</p>
							) : null}
						</div>
					</div>
				) : null
				}
			</div >
		</div >
	);
};

export default UnAvailableReasons;
